import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { StorageService } from './storage.service'

const ThemeClasses = {
    DARK_MODE: '_mode_dark',
}

@Injectable({
    providedIn: 'root',
})
export class ThemeSwitcherService {
    private body!: HTMLBodyElement
    private _isDarkModeEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

    isDarkModeEnabled$: Observable<boolean>

    constructor(private storage: StorageService) {
        this.body = document.getElementsByTagName('body')[0] as HTMLBodyElement
        this.loadTheme()
        this.isDarkModeEnabled$ = this._isDarkModeEnabled$.asObservable()
        window.addEventListener('beforeunload', this.saveTheme.bind(this))
    }

    changeBodyClass(isDarkModeEnabled: boolean) {
        if (isDarkModeEnabled) this.body.classList.add(ThemeClasses.DARK_MODE)
        else this.body.classList.remove(ThemeClasses.DARK_MODE)
    }

    toggleTheme() {
        this._isDarkModeEnabled$.next(!this._isDarkModeEnabled$.value)
        this.changeBodyClass(this._isDarkModeEnabled$.value)
    }

    public loadTheme() {
        const value = this.storage.getItem('isDarkModeEnabled', false)
        this._isDarkModeEnabled$ = new BehaviorSubject(value)
        this.changeBodyClass(value)
    }

    public saveTheme() {
        this.storage.setItem('isDarkModeEnabled', this._isDarkModeEnabled$.value)
    }
}
